import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CartEntry, Product, ShoppingCartState } from '@shared-models';

export const shoppingCartFeatureSelector =
  createFeatureSelector<ShoppingCartState>('shoppingCart');

export const shoppingCartShownSelector = createSelector(
  shoppingCartFeatureSelector,
  (state: ShoppingCartState): boolean => state.shoppingCartShown,
);

export const paymentSuccessfulSelector = createSelector(
  shoppingCartFeatureSelector,
  (state: ShoppingCartState): boolean => state.paymentSuccessfulShown,
);

export const paymentErrorSelector = createSelector(
  shoppingCartFeatureSelector,
  (state: ShoppingCartState): boolean => state.paymentErrorShown,
);

export const paymentCancelSelector = createSelector(
  shoppingCartFeatureSelector,
  (state: ShoppingCartState): boolean => state.paymentCancelShown,
);

export const shoppingCartItemsSelector = createSelector(
  shoppingCartFeatureSelector,
  (state: ShoppingCartState): CartEntry[] => state.shoppingCartItems,
);

export const totalPriceSelector = createSelector(
  shoppingCartItemsSelector,
  (cartItems: CartEntry[]) => {
    return cartItems.reduce((total, cartEntry) => {
      const totalForCartEntry = cartEntry.products.reduce(
        (entryTotal, product: Product) => {
          const productPrice = +product.price * product.quantity;
          const gearPrice = product.gearData.reduce((total, gear) => {
            return total + gear.projectedPriceWithDiscount;
          }, 0);

          return entryTotal + +productPrice.toFixed(2) + +gearPrice.toFixed(2);
        },
        0,
      );

      return total + totalForCartEntry;
    }, 0);
  },
);

export const acceptPolicySelector = createSelector(
  shoppingCartFeatureSelector,
  (state: ShoppingCartState): boolean => state.acceptPolicy,
);

export const focusAcceptPolicySelector = createSelector(
  shoppingCartFeatureSelector,
  (state: ShoppingCartState): boolean => state.focusAcceptPolicy,
);

export const shoppingCartIdSelector = createSelector(
  shoppingCartFeatureSelector,
  (state: ShoppingCartState): string => state.shoppingCartId,
);
